import React, { useEffect, useState } from "react";
import CustomInput from "../../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getCategories } from "../features/CountrySclice";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import { v4 as uuidv4 } from 'uuid';
import {
  createNewNewsCat,
  getANewsCat,
  resetState,
  updateANewsCat,
  getANewsCatt
} from "../features/CountryCatSclice";

let schema = yup.object().shape({
  id: yup.string(),
  categoryName: yup.string().required("Category is Required"),
  description: yup.string().required("Description is Required"),
  link: yup.string().required("Link is Required"),
  type: yup.string().required("Type is Required"),
});

const AddNewscat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const bCatState = useSelector((state) => state.country.bCategories);
  const pathSegments = location.pathname.split("/");
  const getNewsCatId = pathSegments[3];
  const getNewsCatIdd = pathSegments[4];
  const newNewsCategory = useSelector((state) => state.countryCat);
  const [uuid, setUuid] = useState(uuidv4());
  const {
    isSuccess,
    isError,
    isLoading,
    createNewsCategory,
    categoryName,
    description,
    countryName,
    link,
    type,
    updatedNewsCategory,
  } = newNewsCategory;

  useEffect(() => {
    if (getNewsCatId !== undefined && getNewsCatIdd !== undefined) {
      dispatch(getANewsCatt(getNewsCatId));
      dispatch(getCategories());
      dispatch(getANewsCat({ id: getNewsCatId, secondId: getNewsCatIdd }));
    } else {
      dispatch(resetState());
      dispatch(getCategories());
    }
  }, [dispatch, getNewsCatId, getNewsCatIdd]);

  useEffect(() => {
    if (!getNewsCatId) {
      dispatch(getCategories());
    }
  }, [dispatch, getNewsCatId]);

  useEffect(() => {
    if (isSuccess && (createNewsCategory || updatedNewsCategory)) {
      const successMessage = getNewsCatId !== undefined ? "Updated" : "Added";
      toast.success(`Country Category ${successMessage} Successfully!`);
      navigate("/admin/Country-Category-List");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading, createNewsCategory, updatedNewsCategory, getNewsCatId, navigate]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {

      hexCode: "#ff9d96",
      order: 0,
      id: getNewsCatIdd || uuid,
      categoryName: categoryName || "",
      description: description || "",
      link: link || "",
      type: type || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {

      if (getNewsCatId !== undefined) {
        dispatch(updateANewsCat({ id: getNewsCatId, secondId: getNewsCatIdd, NewsCatData: values }));
      } else {
        dispatch(createNewNewsCat(values));
        formik.resetForm();
      }
      dispatch(resetState());
    },
  });

  return (
    <div>

      <h3 className="mb-4 title">
        {getNewsCatId !== undefined ? "Edit" : "Add"} Country Category
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          {getNewsCatId === undefined ? (
            <select
              name="countryNamee"
              onChange={formik.handleChange("countryNamee")}
              onBlur={formik.handleBlur("countryNamee")}
              value={formik.values.countryNamee}
              className="form-control py-3 mt-3"
            >
              <option value="">Select Country Name</option>
              {bCatState.map((i, j) => (
                <option key={j} value={i.data.id}>
                  {i.data.countryName}
                </option>
              ))}
            </select>
          ) : null}

          <div className="error">{formik.touched.countryNamee && formik.errors.countryNamee}</div>

          <CustomInput
            type="text"
            name="id"
            onChng={formik.handleChange("id")}
            onBlr={formik.handleBlur("id")}
            val={formik.values.id}
            label="ID"
            id="id"
            disabled={getNewsCatId !== undefined}
          />
          <CustomInput
            type="text"
            name="categoryName"
            onChng={formik.handleChange("categoryName")}
            onBlr={formik.handleBlur("categoryName")}
            val={formik.values.categoryName}
            label="Enter Category Name"
            id="categoryName"
          />
          <div className="error">
            {formik.touched.categoryName && formik.errors.categoryName}
          </div>

          <CustomInput
            type="text"
            name="description"
            onChng={formik.handleChange("description")}
            onBlr={formik.handleBlur("description")}
            val={formik.values.description}
            label="Enter Description"
            id="description"
          />
          <div className="error">
            {formik.touched.description && formik.errors.description}
          </div>

          <CustomInput
            type="text"
            name="link"
            onChng={formik.handleChange("link")}
            onBlr={formik.handleBlur("link")}
            val={formik.values.link}
            label="Enter Image Link"
            id="link"
          />
          <div className="error">
            {formik.touched.link && formik.errors.link}
          </div>

          <CustomInput
            type="text"
            name="type"
            onChng={formik.handleChange("type")}
            onBlr={formik.handleBlur("type")}
            val={formik.values.type}
            label="Topics coverd"
            id="type"
          />
          <div className="error">
            {formik.touched.type && formik.errors.type}
          </div>

          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
            disabled={isLoading}
          >
            {isLoading && (
              <div className="loader"></div>
            )}
            {isLoading ? "" : getNewsCatId !== undefined ? "Edit" : "Add"} Country Category
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewscat;
